import { Switch, withStyles } from "@material-ui/core";

const CustomSwitch = withStyles({
    switchBase: {
        color: "#1367B2",
        '&$checked': {
            color: "#1367B2",
        },
        '&$checked + $track': {
            backgroundColor: "#1367B2",
        },
    },
    checked: {},
    track: {
        backgroundColor: "#1367B2",
    },
})(Switch);


function AvailabilityToggle({ checked, onChange }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'end', fontSize: 14, color: "#212121" }}>
            <CustomSwitch checked={checked} onChange={onChange} />
            <span>Show Availability</span>
        </div>
    );
}

export default AvailabilityToggle;
